module.exports = __webpack_public_path__ + "img/suppliers_blue.dc544bf3.svg";